import { View } from 'react-native'
import Gradient from '@ui/effects/Gradient'
import { colors as c } from '@ui/colors'
import cn from '@ui/utils/cn'
import { NumberUtils } from '@ca/common'
import { PaymentStatusAmounts } from '@order/hooks/usePaymentStatusAmounts'

const sLine = 'h-4 max-h-4 overflow-hidden rounded-sm'

export default function PaymentProgress({
  amounts,
}: {
  amounts: PaymentStatusAmounts
}) {
  const { processing, paid, total } = amounts

  return (
    <View
      className={cn(sLine, 'flex h-8 w-full flex-1 flex-row gap-0 bg-black/10')}
    >
      {processing >= 0 && (
        <View
          className={cn(sLine, 'absolute top-0')}
          style={{
            width: `${NumberUtils.percentage.getSafe(processing, total)}%`,
            top: 0,
            left: `${NumberUtils.percentage.getSafe(paid, total)}%`,
            transform: [{ translateX: -12 }],
          }}
        >
          <Gradient
            colors={[c.amber[200], c.amber[400]]}
            start={[0, 0.5]}
            end={[1, 0.5]}
          />
        </View>
      )}
      {paid >= 0 && (
        <View
          className={cn(sLine)}
          style={{ width: `${NumberUtils.percentage.getSafe(paid, total)}%` }}
        >
          <Gradient
            colors={[c.green[500], c.green[600]]}
            start={[0, 0.5]}
            end={[1, 0.5]}
          />
        </View>
      )}
    </View>
  )
}
